import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin({
  setup() {
    const language = useCurrentLanguage()
    useHead({
      script: [
        // ✅ Google Consent Mode Script
        {
          children: `
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag("consent", "default", {
              ad_user_data: "denied",
              ad_personalization: "denied",
              ad_storage: "denied",
              analytics_storage: "denied",
              wait_for_update: 2000
            });
            gtag("set", "ads_data_redaction", true);
          `,
          type: "text/javascript"
        },
        // ✅ Usercentrics CMP Script
        {
          src: "https://web.cmp.usercentrics.eu/ui/loader.js",
          id: "usercentrics-cmp",
          "data-settings-id": "4sShsrDZx-2wZn",
          "data-language": language.value ?? 'de',
          "data-tcf-enabled": true,
          async: true
        },
        // ✅ Google Tag Manager Script
        // Temporary commented due to the issue with the onetrust-consent-sdk
        {
          children: `
            (function(w,d,s,l,i){
              w[l] = w[l] || [];
              w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
              var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l != 'dataLayer' ? '&l=' + l : '';
              j.async = true;
              j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
              f.parentNode.insertBefore(j,f);
            })(window, document, 'script', 'dataLayer', 'GTM-P4W7TB2');
          `,
          type: "text/javascript"
        }
      ],
      noscript: [
        {
          children: `
            <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P4W7TB2" height="0" width="0" style="display:none;visibility:hidden"></iframe>
          `
        }
      ]
    });
  }
});
